const star1 = '.:*・°☆';
const star2 = '・.:*・☆';
const star3 = '°・.:*☆';
const star4 = '・°・.:☆';
const star5 = '*・°・.☆';
const star6 = ':*・°・☆';

const starArray = [star1, star2, star3, star4, star5, star6];

const starLength = starArray.length;

// window.onload =
// $("a.fancy").hover(function(){
//   let hoverContainer = $(this).find(".hover");
//   console.log(hoverContainer)
//   hoverContainer.addClass('rotate-text');
//   loop(0, hoverContainer);
// })

// function loop(i, hover) {
//   console.log(hover)
//   hover.innerHTML = starArray[i % starLength];
//   setTimeout(function () {
//     loop(i + 1, hover);
//   }, 575);
// }

window.onload = function () {
  let animation;
  $('a.fancy').mouseenter(function () {
    animation = true;
    let hoverClass = $(this).find('.hover');
    loop(0, hoverClass);
    // typewrite.addClass('rotate-text');
  });

  $('a.fancy').mouseleave(function () {
    animation = false;
  });

  function loop(i, hoverClass) {
    //if off dont do anything
    if (animation) {
      hoverClass.text(starArray[i % starLength]);
      setTimeout(function () {
        loop(i + 1, hoverClass);
      }, 105);
    } else {
      return;
    }
  }
};
